import axiosInstance from "./AxiosConfig";

class RegisteredClients {
  //   async CreateClient() {}

  async GetAllRegisteredClients(pageNo = 1, pageLimit = 100, searchCriteria = "All", searchText = "") {
    try {
      const response = await axiosInstance.get("/registerClient/getall", {
        params: { pageNo, pageLimit, searchCriteria, searchText },
      });
      console.log("Get All response", response);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async UpdateF3(id, F3) {
    try {
      const response = await axiosInstance.put(`/registerClient/update-f3/${id}`, { F3 });
      return response.data;
    } catch (error) {
      console.error(error);
      return {
        StatusCode: error?.response?.status,
        IsSuccess: false,
        ErrorMessages:
          error?.response?.data?.ErrorMessages ||
          error?.response?.data?.message ||
          error?.message ||
          "Request failed",
      };
    }
  }
}

export default new RegisteredClients();
